<template>
  <div>
    <b-badge class="p-2" :variant="'status_'+status">{{ $t(history_event_translator[status]) }}</b-badge>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    events: {
      type: Array,
      default: undefined,
    },
    static_status: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      history_event_translator: [
        "", // 0
        "transaction_status.history_event_draft", // 1
        "transaction_status.history_event_read", // 2
        "transaction_status.history_event_waiting_review", // 3
        "transaction_status.history_event_pending", // 4
        "transaction_status.history_event_paid", // 5
        "transaction_status.history_event_waiting_send", // 6
        "transaction_status.history_event_sent", // 7
        "transaction_status.history_event_received", // 8
        "transaction_status.history_event_cancelled", // 9
        "transaction_status.history_event_refund", // 10
        "transaction_status.history_event_contact_failed", // 11
        "transaction_status.history_event_reprocess", // 12
        "transaction_status.history_event_in_process", // 13
        "transaction_status.history_event_missing_auth_letter", // 14
        "transaction_status.history_event_missing_recipe", // 15
        "transaction_status.history_event_contact_provider", // 16
        "transaction_status.history_event_px_contact_failed", // 17
        "transaction_status.history_event_px_contact_success", // 18
        "transaction_status.history_event_scheduled_delivery", // 19
        "transaction_status.history_event_re_scheduled_delivery", // 20
        "transaction_status.history_event_delivery_not_accepted", // 21
        "transaction_status.history_event_delivery_not_made", // 22
        "transaction_status.history_event_finish", // 23
        "transaction_status.history_event_unread", // 24
      ],
    };
  },
  computed: {
    status() {
      if (this.static_status) {
        return this.static_status;
      }
      if (!this.events) {
        return undefined;
      }
      let events = this.events;
      let sorted = events.sort((a, b) => {
        let date_a = new Date(a.event_date);
        let date_b = new Date(b.event_date);

        if (date_a < date_b) {
          return 1;
        }
        if (date_a > date_b) {
          return -1;
        }
        return 0;
      });
      return sorted[0].event_type;
    },
  },
  mounted() {},
  methods: {},
  fallbackI18n: {
    messages: {
      und: {
        transaction_status: {
          history_event_draft: "Draft",
          history_event_read: "Read",
          history_event_waiting_review: "Waiting review",
          history_event_pending: "Pending",
          history_event_paid: "Paid",
          history_event_waiting_send: "Waiting send",
          history_event_sent: "Sent",
          history_event_received: "Received",
          history_event_cancelled: "Cancelled",
          history_event_refund: "Refund",
          history_event_contact_failed: "Contact failed",
          history_event_reprocess: "Reprocess",
          history_event_in_process: "In_process",
          history_event_missing_auth_letter: "Missing auth letter",
          history_event_missing_recipe: "Missing recipe",
          history_event_contact_provider: "Contact provider",
          history_event_px_contact_failed: "Px contact failed",
          history_event_px_contact_success: "Px contact success",
          history_event_scheduled_delivery: "Scheduled delivery",
          history_event_re_scheduled_delivery: "Re scheduled delivery",
          history_event_delivery_not_accepted: "Delivery not accepted",
          history_event_delivery_not_made: "Delivery not made",
          history_event_finish: "Finish",
          history_event_unread: "Unread",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// EVENT_TYPE_DRAFT
.badge-status_1 {
  background-color: $white;
}
// EVENT_TYPE_READ
.badge-status_2 {
  color: $black;
  background-color: #f9f400;
}
// EVENT_TYPE_WAITING_REVIEW
.badge-status_3 {
  color: $white;
  background-color: #006cf6;
}
// EVENT_TYPE_PENDING
.badge-status_4 {
  color: $white;
  background-color: #f0b552;
}
// EVENT_TYPE_PAID
.badge-status_5 {
  color: $white;
  background-color: #0026c5;
}
// EVENT_TYPE_WAITING_SEND
.badge-status_6 {
  color: $white;
  background-color: #ff3300;
}
// EVENT_TYPE_SENT
.badge-status_7 {
  color: $white;
  background-color: #00cc66;
}
// EVENT_TYPE_RECEIVED
.badge-status_8 {
  color: $white;
  background-color: #66cc00;
}
// EVENT_TYPE_CANCELLED
.badge-status_9 {
  color: $white;
  background-color: #f9031b;
}
// EVENT_TYPE_REFUND
.badge-status_10 {
  color: $white;
  background-color: red;
}
// EVENT_TYPE_CONTACT_FAILED
.badge-status_11 {
  color: $white;
  background-color: #a9338c;
}
// EVENT_TYPE_REPROCESS
.badge-status_12 {
  color: $white;
  background-color: #ff9900;
}
// EVENT_TYPE_IN_PROCESS
.badge-status_13 {
  color: $white;
  background-color: #99ccff;
}
// EVENT_TYPE_MISSING_AUTH_LETTER
.badge-status_14 {
  color: $white;
  background-color: #ee7197;
}
// EVENT_TYPE_MISSING_RECIPE
.badge-status_15 {
  color: $white;
  background-color: #ff62d9;
}
// EVENT_TYPE_CONTACT_PROVIDER
.badge-status_16 {
  color: $white;
  background-color: #ff0099;
}
// EVENT_TYPE_PX_CONTACT_FAILED
.badge-status_17 {
  color: $white;
  background-color: #cc0033;
}
// EVENT_TYPE_PX_CONTACT_SUCCESS
.badge-status_18 {
  color: $white;
  background-color: #009999;
}
// EVENT_TYPE_SCHEDULED_DELIVERY
.badge-status_19 {
  color: $white;
  background-color: #009966;
}
// EVENT_TYPE_RE_SCHEDULED_DELIVERY
.badge-status_20 {
  color: $white;
  background-color: #660066;
}
// EVENT_TYPE_DELIVERY_NOT_ACCEPTED
.badge-status_21 {
  color: $white;
  background-color: #cc3333;
}
// EVENT_TYPE_DELIVERY_NOT_MADE
.badge-status_22 {
  color: $white;
  background-color: #ec6701;
}
// EVENT_TYPE_FINISH
.badge-status_23 {
  color: $white;
  background-color: #098202;
}
// EVENT_TYPE_UNREAD
.badge-status_24 {
  color: $white;
  background-color: #3f3f3f;
}
</style>
